import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "rounded-[24px] border border-slate-200 bg-white p-4 shadow-[0_18px_50px_rgba(15,23,42,0.06)]"
};
const _hoisted_2 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_3 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_4 = {
  class: "grid gap-4 lg:grid-cols-[420px_1fr]"
};
const _hoisted_5 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_6 = {
  class: "mt-4 space-y-3"
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_9 = {
  class: "mt-4 max-h-[420px] overflow-auto rounded-xl bg-slate-950 p-4 text-xs leading-5 text-slate-100"
};
const _hoisted_10 = {
  class: "max-w-3xl rounded-2xl border border-slate-200 p-4"
};
const _hoisted_11 = {
  class: "mt-4 space-y-4"
};
const _hoisted_12 = {
  class: "block"
};
const _hoisted_13 = {
  class: "block"
};
const _hoisted_14 = {
  class: "block"
};
const _hoisted_15 = {
  class: "inline-flex items-center gap-2 text-sm text-slate-700"
};
const _hoisted_16 = ["disabled"];
import { defineComponent, h, onMounted, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { getTencentEsignSeals, getTencentEsignTemplates, modifyTencentCallback, queryTencentUserVerifyStatus } from '@/api/esign';
import { blank, readArray, safeJson, statusClassByResult } from './esign-utils';
export default {
  __name: 'TencentEsignResourceManagement',
  setup(__props) {
    const activeTab = ref('templates');
    const templateLoading = ref(false);
    const sealLoading = ref(false);
    const verifyLoading = ref(false);
    const callbackSubmitting = ref(false);
    const templates = ref([]);
    const seals = ref([]);
    const verifyResult = ref(null);
    const templateFilters = reactive({
      keyword: ''
    });
    const sealFilters = reactive({
      keyword: ''
    });
    const verifyForm = reactive({
      name: '',
      mobile: '',
      idCardNumber: ''
    });
    const callbackForm = reactive({
      callbackUrl: '',
      callbackKey: '',
      eventTypes: 'FLOW,APPROVER',
      enabled: true
    });
    const ResourceTable = defineComponent({
      name: 'ResourceTable',
      props: {
        loading: Boolean,
        items: {
          type: Array,
          default: () => []
        },
        type: {
          type: String,
          default: 'template'
        }
      },
      setup(props) {
        return () => h('div', {
          class: 'data-table-shell'
        }, [h('div', {
          class: 'data-table-scroll'
        }, [h('table', {
          class: 'data-table text-sm'
        }, [h('thead', {
          class: 'data-table-head'
        }, [h('tr', [h('th', {
          class: 'data-table-th text-left'
        }, props.type === 'seal' ? '印章 ID' : '模板 ID'), h('th', {
          class: 'data-table-th text-left'
        }, props.type === 'seal' ? '印章名称' : '模板名称'), h('th', {
          class: 'data-table-th text-left'
        }, props.type === 'seal' ? '类型' : '状态'), h('th', {
          class: 'data-table-th text-left data-table-sticky-right data-table-sticky-head data-table-sticky-action'
        }, '预览')])]), h('tbody', props.loading ? [h('tr', {
          class: 'data-table-row'
        }, [h('td', {
          class: 'data-table-empty',
          colspan: 4
        }, '正在加载...')])] : props.items.length ? props.items.map(item => h('tr', {
          class: 'data-table-row',
          key: item.templateId || item.sealId || item.id
        }, [h('td', {
          class: 'data-table-td font-mono text-xs'
        }, props.type === 'seal' ? blank(item.sealId || item.id) : blank(item.templateId || item.id)), h('td', {
          class: 'data-table-td'
        }, props.type === 'seal' ? blank(item.sealName || item.name) : blank(item.templateName || item.name)), h('td', {
          class: 'data-table-td'
        }, [h('span', {
          class: ['status-badge', statusClassByResult(item.status || item.sealStatus)]
        }, blank(props.type === 'seal' ? item.sealType || item.sealStatus || item.status : item.status))]), h('td', {
          class: 'data-table-td data-table-sticky-right data-table-sticky-action'
        }, item.previewUrl ? h('a', {
          class: 'table-action-button is-primary',
          href: item.previewUrl,
          target: '_blank',
          rel: 'noreferrer'
        }, '打开') : '-')])) : [h('tr', {
          class: 'data-table-row'
        }, [h('td', {
          class: 'data-table-empty',
          colspan: 4
        }, '暂无数据')])])])])]);
      }
    });
    const fetchTemplates = async () => {
      templateLoading.value = true;
      try {
        templates.value = readArray(await getTencentEsignTemplates({
          ...templateFilters
        }));
      } catch (error) {
        ElMessage.error(error.message || '查询腾讯模板失败');
      } finally {
        templateLoading.value = false;
      }
    };
    const fetchSeals = async () => {
      sealLoading.value = true;
      try {
        seals.value = readArray(await getTencentEsignSeals({
          ...sealFilters
        }));
      } catch (error) {
        ElMessage.error(error.message || '查询企业印章失败');
      } finally {
        sealLoading.value = false;
      }
    };
    const queryVerify = async () => {
      if (!verifyForm.mobile) {
        ElMessage.warning('请填写手机号');
        return;
      }
      verifyLoading.value = true;
      try {
        verifyResult.value = await queryTencentUserVerifyStatus({
          ...verifyForm
        });
      } catch (error) {
        ElMessage.error(error.message || '查询实名状态失败');
      } finally {
        verifyLoading.value = false;
      }
    };
    const submitCallback = async () => {
      if (!callbackForm.callbackUrl) {
        ElMessage.warning('请填写回调 URL');
        return;
      }
      callbackSubmitting.value = true;
      try {
        await modifyTencentCallback({
          ...callbackForm
        });
        ElMessage.success('回调配置已提交');
      } catch (error) {
        ElMessage.error(error.message || '保存回调配置失败');
      } finally {
        callbackSubmitting.value = false;
      }
    };
    onMounted(() => {
      fetchTemplates();
      fetchSeals();
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", null, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "腾讯电子签资源"), _createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, "查询腾讯侧模板、企业印章、用户实名状态，并维护应用回调配置。")])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => activeTab.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "腾讯模板",
            name: "templates"
          }, {
            default: _withCtx(() => [_createVNode(PageFilterBar, {
              "shell-class": "filter-bar-shell is-embedded",
              "body-class": "filter-bar-body is-embedded",
              "show-refresh": true,
              "refresh-loading": templateLoading.value,
              onRefresh: fetchTemplates
            }, {
              searchActions: _withCtx(() => [_createElementVNode("button", {
                class: "btn-primary",
                type: "button",
                onClick: fetchTemplates
              }, "搜索")]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => templateFilters.keyword = $event),
                class: "form-search-input form-control-sm w-full",
                placeholder: "搜索模板名称或 ID",
                onKeyup: _withKeys(fetchTemplates, ["enter"])
              }, null, 544), [[_vModelText, templateFilters.keyword]]), _cache[11] || (_cache[11] = _createElementVNode("svg", {
                class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              })], -1))])]),
              _: 1
            }, 8, ["refresh-loading"]), _createVNode(_unref(ResourceTable), {
              loading: templateLoading.value,
              items: templates.value,
              type: "template"
            }, null, 8, ["loading", "items"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "企业印章",
            name: "seals"
          }, {
            default: _withCtx(() => [_createVNode(PageFilterBar, {
              "shell-class": "filter-bar-shell is-embedded",
              "body-class": "filter-bar-body is-embedded",
              "show-refresh": true,
              "refresh-loading": sealLoading.value,
              onRefresh: fetchSeals
            }, {
              searchActions: _withCtx(() => [_createElementVNode("button", {
                class: "btn-primary",
                type: "button",
                onClick: fetchSeals
              }, "搜索")]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => sealFilters.keyword = $event),
                class: "form-search-input form-control-sm w-full",
                placeholder: "搜索印章名称或 ID",
                onKeyup: _withKeys(fetchSeals, ["enter"])
              }, null, 544), [[_vModelText, sealFilters.keyword]]), _cache[12] || (_cache[12] = _createElementVNode("svg", {
                class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              })], -1))])]),
              _: 1
            }, 8, ["refresh-loading"]), _createVNode(_unref(ResourceTable), {
              loading: sealLoading.value,
              items: seals.value,
              type: "seal"
            }, null, 8, ["loading", "items"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "实名状态",
            name: "verify"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[13] || (_cache[13] = _createElementVNode("h3", {
              class: "text-sm font-semibold text-slate-900"
            }, "实名状态查询", -1)), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => verifyForm.name = $event),
              class: "form-input w-full",
              placeholder: "姓名"
            }, null, 512), [[_vModelText, verifyForm.name]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => verifyForm.mobile = $event),
              class: "form-input w-full",
              placeholder: "手机号"
            }, null, 512), [[_vModelText, verifyForm.mobile]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => verifyForm.idCardNumber = $event),
              class: "form-input w-full",
              placeholder: "证件号，可选"
            }, null, 512), [[_vModelText, verifyForm.idCardNumber]]), _createElementVNode("button", {
              class: "btn-primary w-full",
              type: "button",
              disabled: verifyLoading.value,
              onClick: queryVerify
            }, "查询实名状态", 8, _hoisted_7)])]), _createElementVNode("div", _hoisted_8, [_cache[14] || (_cache[14] = _createElementVNode("h3", {
              class: "text-sm font-semibold text-slate-900"
            }, "查询结果", -1)), _createElementVNode("pre", _hoisted_9, _toDisplayString(_unref(safeJson)(verifyResult.value) || '暂无查询结果'), 1)])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "回调配置",
            name: "callback"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[19] || (_cache[19] = _createElementVNode("h3", {
              class: "text-sm font-semibold text-slate-900"
            }, "修改腾讯回调配置", -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("label", _hoisted_12, [_cache[15] || (_cache[15] = _createElementVNode("span", {
              class: "text-sm text-slate-600"
            }, "回调 URL", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => callbackForm.callbackUrl = $event),
              class: "form-input mt-1 w-full",
              placeholder: "https://example.com/api/open/esign/tencent/callback"
            }, null, 512), [[_vModelText, callbackForm.callbackUrl]])]), _createElementVNode("label", _hoisted_13, [_cache[16] || (_cache[16] = _createElementVNode("span", {
              class: "text-sm text-slate-600"
            }, "Callback Key", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => callbackForm.callbackKey = $event),
              class: "form-input mt-1 w-full",
              placeholder: "腾讯电子签回调密钥"
            }, null, 512), [[_vModelText, callbackForm.callbackKey]])]), _createElementVNode("label", _hoisted_14, [_cache[17] || (_cache[17] = _createElementVNode("span", {
              class: "text-sm text-slate-600"
            }, "事件类型", -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => callbackForm.eventTypes = $event),
              class: "form-input mt-1 w-full",
              placeholder: "FLOW,APPROVER，可按后端约定填写"
            }, null, 512), [[_vModelText, callbackForm.eventTypes]])]), _createElementVNode("label", _hoisted_15, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => callbackForm.enabled = $event),
              type: "checkbox",
              class: "form-check"
            }, null, 512), [[_vModelCheckbox, callbackForm.enabled]]), _cache[18] || (_cache[18] = _createTextVNode(" 启用回调 ", -1))]), _createElementVNode("div", null, [_createElementVNode("button", {
              class: "btn-primary",
              type: "button",
              disabled: callbackSubmitting.value,
              onClick: submitCallback
            }, "保存回调配置", 8, _hoisted_16)])])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      });
    };
  }
};